<div class="p-2 p-lg-4 container-fluid">
  <h4>Estas são as instituições às quais tem acesso. Para se candidatar a um programa, seleccione uma das instituições!</h4>
  <div class="row">
    <div class="col">
      <div class="card shadow">
        <p-table styleClass="p-datatable-gridlines" [value]="personInstitutions" [autoLayout]="true">
          <ng-template pTemplate="header">
            <tr>
              <th scope="col">Designação</th>
              <th scope="col">N.º Contribuinte</th>
              <!--                            <th scope="col"></th>-->
              <th scope="col"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-record>
            <tr>
              <td class="text-center">{{ record.institution?.designation }}</td>
              <td class="text-center">{{ record.institution?.corporateTaxpayerNumber }}</td>
              <!--                            <td class="text-center">-->
              <!--                                <button (click)="openInstitutionModal(record.institution?.id)" class="btn btn-sm btn-outline-primary">-->
              <!--                                    <fa-icon [fixedWidth]="true" [icon]="'id-card-alt'"></fa-icon>&nbsp;Visualizar Instituição-->
              <!--                                </button>-->
              <!--                            </td>-->
              <td class="text-center">
                <button
                  (click)="selectInstitution(record.institution)"
                  *ngIf="record.institution?.id !== institution?.id"
                  class="btn btn-sm btn-outline-primary"
                >
                  <fa-icon [fixedWidth]="true" [icon]="'id-card-alt'"></fa-icon>&nbsp;Seleccionar esta Instituição
                </button>
                <button
                  (click)="selectInstitution()"
                  *ngIf="record.institution?.id === institution?.id"
                  class="btn btn-sm btn btn-sm btn-outline-secondary"
                >
                  <fa-icon [fixedWidth]="true" [icon]="'id-card-alt'"></fa-icon>&nbsp;Sair da Instituição Ativa
                </button>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>
